import { STATIC_PATH } from '@shared/constants/ImageConstants';

export const TEXTS = {
    TITLE: 'New Filter',
    SUBTITLE: 'Add a name to your new filter',
    INPUT_LABEL: 'Filter Name',
    SAVE_BUTTON_LABEL: 'Save',
    CANCEL_BUTTON_LABEL: 'Cancel',
};

export const BACKGROUND_IMAGE = `${STATIC_PATH}/unsplash/unsplash_202104061201.png`;

export const SAVE_MODAL_TEST_IDS = {
    INPUT: 'save-modal-input',
    SAVE_BUTTON: 'save-modal-save-button',
};

export const SAVE_MODAL_AUTO_TEST_IDS = {
    INPUT: 'save-modal-input',
    SAVE_BUTTON: 'save-modal-save-button',
    CANCEL_BUTON: 'save-modal-cancel-button',
};
